import axios from "axios";
import { getUserId } from "./user";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers["X-User-Id"] = getUserId();
  return config;
});

// Cloudflare sits in front of production and occasionally hands back a 5xx
// (520/522/524) while the origin restarts. Reads are safe to repeat, so retry
// a GET once before letting the error reach the UI.
const TRANSIENT = [502, 503, 504, 520, 521, 522, 523, 524];
client.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  const method = (cfg?.method || "get").toLowerCase();
  const status = error.response?.status;
  const retriable = !error.response || TRANSIENT.includes(status);
  if (cfg && method === "get" && retriable && !cfg.__retried) {
    cfg.__retried = true;
    await new Promise((r) => setTimeout(r, 1200));
    return client(cfg);
  }
  return Promise.reject(error);
});

export default client;

/**
 * A message the member can act on. Gateway hiccups and dropped connections
 * must never be reported as a credential or validation problem.
 */
export function apiErrorMessage(error, fallback) {
  if (!error?.response) return "Couldn't reach the server. Check your connection and try again.";
  const { status, data } = error.response;
  if (status >= 500) return "The server hiccupped on our side. Try again in a moment.";
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  return fallback;
}

// Recording playback — fetched with our auth-injecting client and served
// back as a blob URL. `<video src>` can't attach custom headers itself, so
// we bounce the response through a blob. SECURITY (SEC-003): the old
// query-param `?user=` URL leaked recordings via Referer / logs / caches;
// this replaces it with a proper authenticated fetch.
export async function fetchRecordingBlobUrl(meetingId) {
  const res = await client.get(`/meetings/${meetingId}/recording`, {
    responseType: "blob",
  });
  return URL.createObjectURL(res.data);
}
